import React from 'react'
import {
  TokenPairImage as UIKitTokenPairImage,
  TokenPairImageProps as UIKitTokenPairImageProps,
  TokenImage as UIKitTokenImage,
  ImageProps,
} from '@hunnyswap/uikit'
import { Token } from '@hunnyswap/sdk'
import getTokenLogoURL from 'utils/getTokenLogoURL'

interface TokenPairImageProps extends Omit<UIKitTokenPairImageProps, 'primarySrc' | 'secondarySrc'> {
  primaryToken: Token
  secondaryToken: Token
}

// const path = '/images/tokens'
// const images = {
//   XOXO: `/logo.png`,
//   AVAX: `${path}/AVAX.png`,
//   BNB: `${path}/BNB.png`,
//   BTC: `${path}/BTC.png`,
//   BUSD: `${path}/BUSD.png`,
//   ETH: `${path}/ETH.png`,
//   USDC: `${path}/USDC.png`,
//   USDT: `${path}/USDT.png`,
//   WETH: `${path}/ETH.png`,
// }

export const getImageUrlFromToken = (token: Token) => {
  try {
    return (token as any)?.tokenInfo?.logoURI || getTokenLogoURL(token.address)
  } catch (e) {
    return getTokenLogoURL(token.address)
  }

  // return `${path}/tokens/${token.address}.png`
}

export const TokenPairImage: React.FC<TokenPairImageProps> = ({ primaryToken, secondaryToken, ...props }) => {
  return (
    <UIKitTokenPairImage
      primarySrc={getImageUrlFromToken(primaryToken)}
      secondarySrc={getImageUrlFromToken(secondaryToken)}
      {...props}
    />
  )
}

interface TokenImageProps extends ImageProps {
  token: Token
}

export const TokenImage: React.FC<TokenImageProps> = ({ token, ...props }) => {
  return <UIKitTokenImage src={getImageUrlFromToken(token)} {...props} />
}
